import { render, staticRenderFns } from "./ProviderDatabasesTab.vue?vue&type=template&id=395a8316"
import script from "./ProviderDatabasesTab.vue?vue&type=script&lang=js"
export * from "./ProviderDatabasesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports